(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soul-space-goodlight-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soul-space-tabs')) {
    customElements.define('soul-space-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.renderState();
          return;
        }
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.activeIndex = 0;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.goodlight__item');
          if (!item) return;
          const index = Number(item.dataset.index);
          this.activeIndex = index;
          this.renderState();
        });
        this.renderState();
      }

      selectTab(index) {
        this.activeIndex = index;
        this.renderState();
      }

      renderState() {
        this.tabs.forEach((tab, itemIndex) => {
          const active = itemIndex === this.activeIndex;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, itemIndex) => {
          panel.hidden = itemIndex !== this.activeIndex;
        });
      }

      onKeydown(event, index) {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.selectTab(next);
        this.tabs[next].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
